import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface CustomerRatingOption {
  value: number
  label: string
}

function useCustomerRatingOptions() {
  const intl = useIntl()

  return useMemo(() => {
    const GOOD: CustomerRatingOption = {
      value: 7,
      label: intl.formatMessage({
        id: 'N0G/hPr37e',
        defaultMessage: 'Good: 7.0+',
        description: 'Customer rating filter label for good ratings (7.0 and above)',
      }),
    }

    const VERY_GOOD: CustomerRatingOption = {
      value: 8,
      label: intl.formatMessage({
        id: 'l2oLdn3EJv',
        defaultMessage: 'Very good: 8.0+',
        description: 'Customer rating filter label for very good ratings (8.0 and above)',
      }),
    }

    const EXCEPTIONAL: CustomerRatingOption = {
      value: 9,
      label: intl.formatMessage({
        id: 'NXvDTZwJvm',
        defaultMessage: 'Exceptional: 9.0+',
        description: 'Customer rating filter label for exceptional ratings (9.0 and above)',
      }),
    }

    const ANY_RATING: CustomerRatingOption = {
      value: 0,
      label: intl.formatMessage({
        id: '3Qw2JpuFZ0',
        defaultMessage: 'Any rating',
        description: 'Customer rating filter label for showing all ratings',
      }),
    }

    const CUSTOMER_RATING_GTE: Record<string, CustomerRatingOption> = {
      GOOD,
      VERY_GOOD,
      EXCEPTIONAL,
      ANY_RATING,
    }

    const CUSTOMER_RATING_GTE_BY_VALUE: Record<string, CustomerRatingOption> = {
      7: GOOD,
      8: VERY_GOOD,
      9: EXCEPTIONAL,
    }

    return {
      CUSTOMER_RATING_GTE,
      CUSTOMER_RATING_GTE_BY_VALUE,
    }
  }, [intl])
}

export default useCustomerRatingOptions
